'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        timestamp = _ref.timestamp,
        stylizr = _ref.stylizr;
    return _react2.default.createElement(
        'div',
        { className: theme.root, 'data-test-tag': '@spp/ui-label' },
        _react2.default.createElement(
            'span',
            { className: theme.sectionName },
            stylizr(text.value, text.markup)
        ),
        _react2.default.createElement(
            'span',
            { className: theme.date, 'data-test-tag': '@spp/ui-label:timestamp' },
            _react2.default.createElement(
                'time',
                { dateTime: timestamp },
                timestamp
            )
        )
    );
};

Label.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        sectionName: _propTypes2.default.string,
        date: _propTypes2.default.string
    }),
    timestamp: _propTypes2.default.string,
    stylizr: _propTypes2.default.func
};

Label.defaultProps = {
    theme: {},
    timestamp: '',
    stylizr: function stylizr(text) {
        return text;
    }
};

exports.default = Label;
//# sourceMappingURL=Label.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-label/lib/cjs/Label.js
 ** module id = 522
 ** module chunks = 1
 **/